<template>   
    <div class="wrapper">
        <div class="custom-select" @click="onSelectedOptions" v-show="!isViewOptions"  ref="dropdown">
            <span>{{ selectedText }}</span>
            <img style="width: 12px; margin-left: 8px;" src="../../../assets/arrow_down.png" />
        </div>
        <div class="options" v-if="isViewOptions">
            <div class="custom-select-active">
                <span>{{ selectedText }}</span>
                <img style="width: 12px; margin-left: 8px;" src="../../../assets/arrow_top2.png" />
            </div>
            <span class="option1" style="top: 36px" @click="select('최신순', 'createdAt')">최신순</span>
            <span class="option2" style="top: 80px; border-radius: 0px 0px 6px 6px; border-top: 0;" @click="select('공감순', 'likeCount')">공감순</span>
        </div>
    </div> 

  

</template>

<script>
export default {
    name: 'sortButton',
    data: function()
    {
        return {
            type: 'createdAt',
            selectedText: '최신순',
            isViewOptions: false
        }
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        onSelectedOptions: function()
        {
            this.isViewOptions = !this.isViewOptions;
        },
        select: function(text, value)
        {
            this.selectedText = text;
            this.type = value
            this.isViewOptions = false;
        },
        handleClickOutside(event) {
            const dropdown = this.$refs.dropdown;
            if (dropdown && !dropdown.contains(event.target)) {
                this.isViewOptions = false; // 예: 드롭다운 닫기
            }
        }
    },
    watch: {
        type: function()
        {
            this.$emit('change', this.type)
        }
    }
}
</script>

<style scoped>
.wrapper {
    display: inline-block;
}
.custom-select {
    box-sizing: border-box;
    width: 94px;
    height: 40px;
    border-radius: 6px;
    background: var(--Gray-60, #6B7684);
    color: var(--Gray-00, #FFF);
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;

    cursor: pointer;
}
.custom-select-active {
    box-sizing: border-box;
    width: 94px;
    height: 40px;
    border-radius: 6px;
    background: var(--Gray-00, #FFF);
    color: var(--Gray-100, #1E1E1E);
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--gray-30-stroke, #E8EAEE);
    z-index: 5;
}
.options{
    display: flex;
    flex-direction: column;
    width: 94px;
    justify-content: flex-start;
    align-items: center;
    z-index: 1;
    position: relative;
}
.option1 {
    display: flex;
    width: 94px;
    height: 44px;
    align-items: center;
    justify-content: flex-start;
    padding-left: 16px;
    background: var(--Gray-00, #FFF);
    box-sizing: border-box;
    color: var(--Gray-100, #1E1E1E);
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    background: var(--Gray-00, #FFF);
    border: 1px solid var(--gray-30-stroke, #E8EAEE);
    z-index: 1;
    position: absolute;
    cursor: pointer;
}
.option2 {
    display: flex;
    width: 94px;
    height: 40px;
    align-items: center;
    justify-content: flex-start;
    padding-left: 16px;
    background: var(--Gray-00, #FFF);
    box-sizing: border-box;
    color: var(--Gray-100, #1E1E1E);
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    background: var(--Gray-00, #FFF);
    border: 1px solid var(--gray-30-stroke, #E8EAEE);
    z-index: 1;
    position: absolute;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/molecules/pc_uncomfortable/SortButton.vue